(() => {
  'use strict';

  if (window.LumeScienceOs2) {
    return;
  }

  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (instances.has(root)) return;

    const reveals = Array.from(root.querySelectorAll('[data-ls-anim]'));
    let observer = null;

    if (reduced || !('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('in'));
    } else {
      root.classList.add('ls-motion-ready');
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach((element) => observer.observe(element));
    }

    instances.set(root, {
      destroy() {
        if (observer) observer.disconnect();
        root.classList.remove('ls-motion-ready');
        reveals.forEach((element) => element.classList.remove('in'));
      },
    });
  }

  function rootsIn(scope) {
    const roots = [];
    if (scope.matches && scope.matches('[data-lume-science-os2]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-lume-science-os2]'));
    return roots;
  }

  function scan(scope) {
    rootsIn(scope).forEach(init);
  }

  function unload(scope) {
    rootsIn(scope).forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });
  }

  window.LumeScienceOs2 = { scan, unload };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
